/**
 * 全站权限配置
 */
import router from '@/router/index'
import store from './store'
import { validatenull } from '@/utils/validate'
import { getToken } from '@/utils/auth'
import { ElMessageBox } from 'element-plus'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'

NProgress.configure({ showSpinner: false })

// const lockPage = store.getters.website.lockPage;
router.beforeEach(
  async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) => {
    // 缓冲设置：判断是否需要 keepAlive
    if (to.path === '/layout') {
      next('/404')
      return
    }
    let title = to?.meta?.title || ''
    document.title = 'SGS SMART' + (title ? '-' + title : '')
    // const isKeepAliveTag = (store.state as any)?.tags?.tagList.some(
    //   (ele: { value: string }) => ele.value === to.fullPath
    // );

    // if (to.meta.$keepAlive === true && isKeepAliveTag) {
    //   to.meta.$keepAlive = true;
    // } else {
    //   NProgress.start();
    //   if (to.meta.keepAlive === true && validatenull(to.meta.$keepAlive)) {
    //     to.meta.$keepAlive = true;
    //   } else {
    //     to.meta.$keepAlive = false;
    //   }
    // }

    const meta = to.meta || {}

    // // 无需认证的页面直接放行
    // if (meta.isAuth === false) {
    //   next();
    //   return;
    // }

    // // 已登录

    if (getToken()) {
      // 如果系统锁屏且目标不是锁屏页，跳转到锁屏页
      // if (store.getters.isLock && to.path !== lockPage) {
      //   next({ path: lockPage });
      //   return;
      // }

      // 已登录却访问登录页，重定向到主页 Dashboard
      if (to.path === '/login') {
        debugger
        window.location.href = window.location.origin + '/#/wel/index'
        return
      }

      // 检查 token 是否在 Vuex 中存在（防止 token 丢失但本地存储还有）
      // if (store.getters.token.length === 0) {
      //   await store.dispatch('FedLogOut');
      //   next({ path: '/login' });
      //   return;
      // }

      // 正常访问
      next()
    } else {
      // 未登录
      if (meta?.isAuth === false) {        
        next()
      } else {
        // 重定向到登录页，并携带来源路径
        // next(`/login?redirectedFrom=${encodeURIComponent(to.fullPath)}`);
        // window.location.href = window.location.origin  + '/web/login'

        import.meta.env.VITE_APP_ENV === 'development'
          ? next(`/login`)
          : (window.location.href = window.location.origin + '/web/login')
      }
    }
  },
)

router.afterEach((to: RouteLocationNormalized) => {
  NProgress.done()

  // const menuMap = store.getters.menuMap;
  // const pathName = menuMap[to.fullPath];
  // const i18n = to.meta.i18n as string | undefined;
  // const menuName = pathName || i18n || (to.name as string | undefined);

  // let title = '';
  // if (menuName) {
  //   // 假设 generateTitle 接受两个参数：name 和 useI18nFlag
  //   title = router.$avueRouter.generateTitle(menuName, !pathName && !!i18n);
  // }

  // 动态设置浏览器标题
  // router.$avueRouter.setTitle(title);
})
